export default "__VITE_ASSET__Cj5H4LiK__"